import { useEffect, useState } from "react";
import { getWaitlistStats } from "@/lib/api";
import { Clock } from "lucide-react";

function computeParts(target) {
  if (!target) return null;
  const diff = new Date(target).getTime() - Date.now();
  if (diff <= 0) return { done: true };
  return {
    days: Math.floor(diff / 86400000),
    hours: Math.floor((diff % 86400000) / 3600000),
    minutes: Math.floor((diff % 3600000) / 60000),
    done: false,
  };
}

export function StickyCountdownBar() {
  const [target, setTarget] = useState(null);
  const [parts, setParts] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("suitecrowd_countdown_dismissed") === "1") {
      setDismissed(true);
    }
    getWaitlistStats().then((s) => setTarget(s.waitlist_closes_at)).catch(() => {});
  }, []);

  useEffect(() => {
    if (!target) return;
    setParts(computeParts(target));
    const it = setInterval(() => setParts(computeParts(target)), 60_000);
    return () => clearInterval(it);
  }, [target]);

  if (dismissed || !parts || parts.done) return null;

  return (
    <div
      data-testid="sticky-countdown"
      className="fixed top-0 left-0 right-0 z-40 bg-[#0B192C] text-white text-[11px] tracking-[0.22em] uppercase py-2 px-6 flex items-center justify-center gap-3"
    >
      <Clock size={12} strokeWidth={1.5} />
      <span className="text-white/70 hidden sm:inline">Iscrizioni Founding Member chiudono in</span>
      <span className="text-white/70 sm:hidden">Chiude in</span>
      <span className="text-white font-medium">
        {parts.days}g {String(parts.hours).padStart(2, "0")}h {String(parts.minutes).padStart(2, "0")}m
      </span>
      <button
        onClick={() => {
          localStorage.setItem("suitecrowd_countdown_dismissed", "1");
          setDismissed(true);
        }}
        className="ml-4 text-white/50 hover:text-white transition-colors text-[14px]"
        aria-label="Chiudi"
      >
        ×
      </button>
    </div>
  );
}
